import { getProjectUsers } from "@/api/project/project"

/**
 * 需要使用的地方提供projectId(或稍后手动调用refreshCurProjectUsers函数)
 */
export default {
  provide() {
    return {
      curProjectUsers: this.curProjectUsers
    }
  },
  data() {
    return {
      curProjectUsers: [],
      curRequestProjectId: null
    }
  },
  created() {
    this.refreshCurProjectUsers() // 需要有当前应用
  },
  methods: {
    refreshCurProjectUsers(projectId = this.projectId) {
      if (!projectId || projectId === this.curRequestProjectId) return

      // 为了防止短时间内进行多次请求,后面发起的请求更早响应导致数据不准确的问题
      this.curRequestProjectId = projectId
      getProjectUsers(projectId).then(users => {
        if (this.curRequestProjectId === projectId) {
          this.curProjectUsers.length = 0
          this.curProjectUsers.push(...users)
        }
      })
    }
  }
}
